import { t } from 'i18next';
import {
  GenericCategory,
  RecordCategory,
  RecordCategoryType,
  Scope,
} from 'queries/events/records/types';
import React from 'react';
import { Message } from 'queries/events/records/contract';
import { formatUserName, getTranslationPath } from '../utils';

const getMessage = ({
  scope,
  category,
  user_email,
  text,
  translate,
}: {
  scope?: Scope;
  category: RecordCategoryType;
  user_email: string;
  text: string;
  translate: boolean;
}) => {
  if (category === RecordCategory.COMMENT) {
    return text;
  }

  const messageScope = Object.values(GenericCategory).find(
    (genericCategory) => genericCategory === category,
  )
    ? Scope.GENERIC
    : scope;

  const user_name = formatUserName(user_email);
  if (translate) {
    const translation_path = getTranslationPath(category, scope);

    const lowerCaseText = text.toLocaleLowerCase();
    const splitByPipe = lowerCaseText.split('|');
    const hasPipe = splitByPipe.length > 1;
    const fieldsText = (hasPipe ? splitByPipe[1] : lowerCaseText).split(',');
    const fieldName = hasPipe ? splitByPipe[0] : undefined;

    return t(`records:category_message.${messageScope}.${category}`, {
      user_name: category === RecordCategory.OWNER_UPDATED ? formatUserName(text) : user_name,
      field: fieldsText
        .map((field) => t(`${translation_path}.${field.toLowerCase()}`, { defaultValue: field }))
        .join(', '),
      name: fieldName,
    });
  }

  return t(`records:category_message.${messageScope}.${category}`, {
    user_name,
    field: text,
  });
};
const RecordsMessageContent: React.FC<{ message: Message; scope?: Scope }> = ({
  scope,
  message,
}) => {
  return <div className="records-body">{getMessage({ scope, ...message })}</div>;
};

export default RecordsMessageContent;
